import React from "react";

import { ClerkUser } from "../api/clerk";
import { ListenTabData, Recommendation } from "../api/albums";

export type ProfileContextValue = {
  userData: ClerkUser;
  friends: ClerkUser[];
  followersCount: number;
  isLoadingFriends: boolean;
  isCurrentUser: boolean;
  isLoaded: boolean;
  fullName: string;
  refreshFriends: () => Promise<void>;
  sent: Recommendation[];
  sentSubtitleByAlbumId: Record<number, string>;
  isLoadingSharedTab: boolean;
  listenTabData: ListenTabData;
  queueRecommendations: Recommendation[];
  doneRecommendations: Recommendation[];
  usersByExternalId: Record<string, ClerkUser>;
  isLoadingListenTab: boolean;
  refreshSharedTab: (options?: { showLoading?: boolean }) => Promise<void>;
  refreshListenTab: (options?: { showLoading?: boolean }) => Promise<void>;
  isFriend: boolean;
  receivedFromFriend: Recommendation[];
  sentToFriend: Recommendation[];
  isLoadingFriendExchange: boolean;
};

const ProfileContext = React.createContext<ProfileContextValue | null>(null);

export function ProfileProvider({
  value,
  children,
}: React.PropsWithChildren<{ value: ProfileContextValue }>) {
  return <ProfileContext.Provider value={value}>{children}</ProfileContext.Provider>;
}

export function useProfile() {
  const context = React.useContext(ProfileContext);

  if (!context) {
    throw new Error("useProfile must be used within ProfileLayout");
  }

  return context;
}
